import 'vant/lib/index.css';
import '@/styles/colors.scss';
// import '@/styles/main.scss';
import 'dayjs/locale/pt-br';
import 'ant-design-vue/dist/reset.css';

import Antd from 'ant-design-vue';
import { createVueWait } from 'vue-wait';

const VueWait = createVueWait();
import 'animate.css';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

import router from './router';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale('pt-br');
import vant, { Locale } from 'vant';
// eslint-disable-next-line import/no-unresolved
import vantPtBR from 'vant/es/locale/lang/pt-BR';

Locale.use('pt-BR', vantPtBR);

import 'vuetify/styles';
import '@/styles/main.scss';

import { BeI18n } from '@beconfident/i18n';
import { createApp } from 'vue';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import VueTheMask from 'vue-the-mask';
import VueApexCharts from 'vue3-apexcharts';
import Markdown from 'vue3-markdown-it';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import logger from '@/infra/logger';
import apiClientPlugin from '@/plugins/api-client';
import axios from '@/plugins/axios';

import { piniaInstance } from './store/pinia';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'beConfidentTheme',
    themes: {
      beConfidentTheme: {
        dark: false,
        colors: {
          primary: getCustomColor('--color-brand-03'),
        },
        variables: {
          '$field-border-width': 0,
        },
      },
    },
  },
});

import App from './App.vue';
import formatCents from './helpers/format-cents';
import formatDate from './helpers/format-date';
import getCustomColor from './helpers/get-custom-color';
import initFirebase from './helpers/init-firebase';
import { tracking } from './helpers/track-event';
import esES from './locales/es-ES';
import ptBR from './locales/pt-BR';

async function init() {
  await initFirebase();

  const translations = {
    'pt-BR': ptBR,
    'es-ES': esES,
    'en-US': {},
  } as const;

  const i18n = new BeI18n({
    translations,
    defaultLanguage: 'pt-BR',
  });

  await i18n.init();

  const app = createApp(App);

  app.config.globalProperties.$i18n = i18n;
  app.config.globalProperties.$filters = {
    formatCents,
    formatDate,
  };

  app.config.compilerOptions.whitespace = 'preserve';

  logger.init(app);

  tracking.init();

  app.use(VueApexCharts);
  app.component('Apexcharts', VueApexCharts);
  app.use(piniaInstance);
  app.use(VueTelInputVuetify);
  app.use(vuetify);
  app.use(Antd);
  app.use(VueWait);
  app.use(router);
  app.use(vant);
  app.use(axios());
  app.use(apiClientPlugin(app));
  // todo:typescript fix any
  app.use(VueTheMask as any);
  app.use(Markdown);
  app.mount('#app');
}

init();
